import styled from 'styled-components'

export const DashMain = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 20px 100px 20px;
  gap: 20px;
  font-family: 'Montserrat', sans-serif;
`
export const HeaderMain = styled.div`
  width: 100%;

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`
export const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(to right, #001842ff, #00205b, #002b80);
  border-radius: 0 27px 0 27px;
  width: 100%;
  height: 60px;
  color: #ffffff;
  z-index: 20000;
  padding: 0 20px;
  font-family: 'Montserrat', sans-serif;

  p:nth-child(1) {
    font-size: 12px;
    font-weight: 800;
    width: 170px;
  }

  .final {
    font-size: 11px;
    padding: 0 15px;
  }

  .li {
    display: flex;
    justify-content: space-between;
    width: 100%;

    span {
      width: 30px;
      font-weight: 800;
    }
  }

  @media (max-width: 768px) {
    height: 50px;
    gap: 30px;
    overflow-x: scroll;
    white-space: nowrap;

    .header-text {
      font-size: 20px;
      font-weight: 800;
      width: 170px;
    }

    .final {
      font-size: 11px;
      padding: 0 15px;
    }

    .li {
      display: flex;
      justify-content: space-between;
      width: 200%;

      span {
        width: 130px;
        font-weight: 800;
      }
    }
  }
`

export const HeaderContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background: rgba(243, 245, 248, 1);
  width: 99%;
  padding: 10px 16px 23px 16px;
  margin: 0 0 0 10px;
  border-radius: 0 0 20px 20px;
  overflow-y: auto;
  box-shadow: 0px 2px 30px 1px rgba(0, 0, 0, 0.2);

  .search {
    width: 100%;

    input {
      height: 50px;
      width: 100%;
      font-family: 'Montserrat', sans-serif;
      padding: 0 10px;
      border-radius: 10px;
      border: none;
      box-shadow: 0 0 30px 5px #00000042;

      &:focus {
        outline: none;
      }
    }
  }

  .selects {
    display: flex;
    margin-top: 30px;
    align-items: center;
    gap: 30px;

    label {
      display: flex;
      gap: 10px;
      font-family: 'Montserrat', sans-serif;
      font-weight: 600;
    }
  }
`

export const CoberturaMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
  height: 180px;
  background-color: rgba(255, 255, 255, 0.6);
  border-radius: 8px;
  border: 1px solid #ddd;
  overflow-y: scroll;
  animation: slideCobertura 1s;
  font-family: 'Montserrat', sans-serif;

  .dados {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 10px;
  }

  @keyframes slideCobertura {
    from {
      height: 0;
      opacity: 0;
      overflow: hidden;
    }
    to {
      height: 180px;
      opacity: 1;
      overflow: hidden;
    }
  }
`
